import React from 'react';
import { Radio } from 'antd';
import { useTranslation } from 'react-i18next';

const HideStreetNumberSelect = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div>
      <h4>{t('common.hideStreetNumber')}</h4>
      <Radio.Group
        onChange={onChange}
        value={value}
        style={{ display: 'flex', flexDirection: 'column' }}
        className="vertical-radio-group"
      >
        <Radio value={true}>
          {t("common.hideStreetNumber")}
        </Radio>

        <Radio value={false}>
          {t("common.showStreetNumber")}
        </Radio>
      </Radio.Group>
    </div>
  );
};

export default HideStreetNumberSelect;
